"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parentAccountHostedZoneId = exports.parentHostedZoneName = exports.parentAcccountId = void 0;
exports.parentAcccountId = '252855055641';
exports.parentHostedZoneName = 'iotv.link';
exports.parentAccountHostedZoneId = 'Z037408026LR1VED1RWZN';
